import {
  aMatchList,
  aMatchListItemPage,
  aMatchListPage,
  mockMatchListsOperationQuery,
} from '__generated__';

export const MATCH_LIST_DATA = {
  name: `Test Match List ${Date.now()}`,
  description: `Test match list description`,
  timeToLive: 3,
  updatedDescription: `Test match list description updated`,
  updatedTimeToLive: 4,
};

export const matchListQuery = mockMatchListsOperationQuery((_req, res, ctx) => {
  return res(
    ctx.delay(1500), // mock loading state
    ctx.data({
      __typename: 'Query',
      matchLists: aMatchListPage({
        hasNextPage: false,
        objects: [
          aMatchList({
            defaultTtl: MATCH_LIST_DATA.timeToLive,
            description: MATCH_LIST_DATA.description,
            id: '1',
            items: aMatchListItemPage({
              hasNextPage: false,
              objects: [],
              total: 0,
            }),
            name: MATCH_LIST_DATA.name,
            targetColumn: '1',
          }),
        ],
        total: 1,
      }),
      matchListItemCount: 1,
      matchListItemLimit: 5,
    })
  );
});

export const handlers = [
  mockMatchListsOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        matchLists: aMatchListPage({
          hasNextPage: false,
          objects: [],
          total: 0,
        }),
        matchListItemCount: 0,
        matchListItemLimit: 1,
      })
    );
  }),
];
